import { ReactNode } from "react";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { searchFilterStore } from "entities/SearchFilter";
import { useAppSelector } from "shared/lib/redux";
import { ValueOf } from "shared/lib/typeCheck.lib";
import { AirCardsByTagView } from "./CardsByTagViews/AirCardsByTagView";
import { SeaCardsByTagView } from "./CardsByTagViews/SeaCardsByTagView";

type CardsByTagViewProps = {
  className?: string;
};

const cardsByTagViewsMap: Record<ValueOf<typeof ShipmentType>, (props: CardsByTagViewProps) => ReactNode> = {
  [ShipmentType.AIR]: (props) => <AirCardsByTagView {...props} />,
  [ShipmentType.SEA]: (props) => <SeaCardsByTagView {...props} />,
  [ShipmentType.RAIL]: (props) => <div {...props} />,
  [ShipmentType.ROAD]: (props) => <div {...props} />,
  [ShipmentType.PARCEL]: (props) => <div {...props} />,
};

export const CardsByTagView: RFC<CardsByTagViewProps> = ({ className }) => {
  const shipmentType = useAppSelector(searchFilterStore.selectors.shipment);

  return cardsByTagViewsMap[shipmentType]?.({ className });
};
